// extracted by mini-css-extract-plugin
export default {"cc-popbox-exist-resume":"OLzdRX23","cc-content-new":"hPu425tp","cc-popbox-exist-info":"_02bN4jE","cc-content-btn-area":"V7vJCWxN","cc-content-btn":"_g25u0vY"};